import t, { Suspense as p, lazy as u } from "react";
import v from "classnames";
import { LandingButton as x } from "../../../features/landing/components/LandingButton/LandingButton.js";
import A from "../../../../common/resources/pointy-arrow.svg.js";
import _ from "../../../../common/resources/stemless-arrow.svg.js";
import r from "./shared-landing.module.scss.js";
const g = u(() => import("../../../features/common/components/RotativeText/RotativeText.js").then((n) => ({ default: n.RotativeText })));
function L(n) {
  const {
    design: a,
    buttons: o,
    rotative: l,
    children: y,
    utmReferral: d
  } = n, f = o.filter((e) => !e.primary), h = o.filter(((e) => e.primary)), m = (e, i, c) => {
    const s = {
      action: e.action,
      backgroundColor: e.primary ? a.general.highlightBackground : a.general.background,
      textColor: e.primary ? a.general.highlightText : a.general.text,
      primary: e.primary,
      utmReferral: d
    }, E = c[i + 1] === void 0 && !e.primary && c.length % 2 !== 0;
    return /* @__PURE__ */ t.createElement(
      x,
      {
        className: v({
          [r.buttonsArea__primaryBtn]: e.primary,
          [r.buttonsArea__normal_btn]: !e.primary,
          [r.buttonsArea__expand]: E
        }),
        ...s,
        key: i
      },
      /* @__PURE__ */ t.createElement(t.Fragment, { key: `${i}-inner` }, e.text, !e.icon && e.primary && /* @__PURE__ */ t.createElement(A, { style: { fill: s.textColor } }), !e.icon && !e.primary && /* @__PURE__ */ t.createElement(_, { style: { fill: s.textColor } }), e.icon && /* @__PURE__ */ t.createElement("img", { src: e.icon, alt: "Arrow" }))
    );
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: r.mainArea,
      "data-testid": "shared-landing-body"
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: r.rotationalArea,
        style: { color: a.startPage.rotationalText }
      },
      /* @__PURE__ */ t.createElement("div", { className: r.rotativeTitle }, l.titles.length > 0 && /* @__PURE__ */ t.createElement(p, { fallback: null }, /* @__PURE__ */ t.createElement(g, { texts: l.titles }))),
      /* @__PURE__ */ t.createElement("div", { className: r.rotativeDesc }, l.subtitles.length > 0 && /* @__PURE__ */ t.createElement(p, { fallback: null }, /* @__PURE__ */ t.createElement(g, { texts: l.subtitles })))
    ),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        style: {
          "--general-line-color": a.general.lines
        },
        className: r.buttonsArea
      },
      f.map(m),
      h.map(m)
    ),
    y
  );
}
export {
  L as SharedLandingBody
};
//# sourceMappingURL=SharedLandingBody.js.map
